/* eslint-disable sonarjs/no-duplicate-string */
import React from 'react';
import { ERoute } from 'common/const';
import { DEFAULT_VALUE_0, STATISTICS_OVERFLOW_COUNT } from 'common/config';
// Tree и Email временно не используются (скрыты «Дерево характеристик» и RFP)
import { Account, Affiliate, Brand, Cart, Catalog, Contract, Drawer, DrawerFull, Exit, Tool } from 'common/svg';
import { getUserName, getUserRole } from 'entities/User/User.helper';
import { IUser, IUserStats } from 'entities/User/User.models';
import { EUserRole } from 'entities/User/User.enum';
// import { ERfpStatus } from 'entities/Rfp/Rfp.enum'; // временно скрыто (RFP убран из интерфейса)

export const getStatisticsItemCount = (count?: number) => {
  if (!count) {
    return DEFAULT_VALUE_0;
  }

  return count > STATISTICS_OVERFLOW_COUNT ? `${count}+` : count;
};

export const getSidebarItemClassName = (isActive: boolean, key: string) => `sidebar-item ${key} ${isActive ? 'active' : ''}`;

export const getSidebarItems = (
  isSeller = false,
  xUserId: number | null,
  xBasketId: number | null,
  currentUser: IUser | null,
  statistics: IUserStats,
  logout: () => void,
) => {
  const { isSuperAdmin, isAccountAdmin, isSellerManager, isManager } = getUserRole(currentUser?.roles);
  const initials = getUserName.initials(currentUser?.lastName, currentUser?.firstName);
  const userName = getUserName.fullLastNameAndInitials(currentUser?.lastName, currentUser?.firstName, currentUser?.patronymic);
  const catalogId = window.location.pathname.startsWith(ERoute.Catalog) ? window.location.pathname.split('/')[2] : null;
  // TODO For future improvement
  // const workspaces = currentUser?.workspaces;

  return {
    body: {
      orangeGroup: [
        // Временно скрыто из меню СА
        // {
        //   key: 'sidebar-catalog-list',
        //   show: isSuperAdmin,
        //   to: ERoute.CatalogList,
        //   icon: <Catalog />,
        //   label: 'Системные каталоги',
        //   description: 'Системные каталоги',
        //   group: 'body',
        // },
        // {
        //   key: 'sidebar-properties-settings',
        //   show: isSuperAdmin,
        //   to: ERoute.PropertiesSettings,
        //   icon: <Tree />,
        //   label: 'Дерево характеристик',
        //   description: 'Дерево характеристик',
        //   group: 'body',
        // },
        {
          key: 'sidebar-brand-settings',
          show: isSuperAdmin,
          to: ERoute.BrandCatalogs,
          icon: <Brand className="icon-brand" />,
          label: 'Каталоги брендов',
          description: 'Каталоги брендов',
          group: 'body',
        },
        {
          key: 'sidebar-city-list',
          show: isSuperAdmin,
          to: ERoute.CityList,
          icon: <Affiliate className="icon-affiliate" />,
          label: 'Города',
          description: 'Города',
          group: 'body',
        },
        {
          key: 'sidebar-catalog',
          show: !isSuperAdmin,
          to: catalogId ? `${ERoute.Catalog}/${catalogId}` : ERoute.Catalog,
          icon: <Catalog />,
          label: 'Каталог',
          description: 'Каталог',
          group: 'body',
        },
        // TODO For future improvement
        // {
        //   key: 'workspace-list',
        //   show: !isSeller && !isSuperAdmin && (isAccountAdmin || (!isAccountAdmin && !!workspaces?.length)),
        //   to: ERoute.WorkspaceList,
        //   icon: <Document className="icon-document" />,
        //   label: 'Карты оснащения',
        // },
      ],
      darkGreenGroup: [
        {
          key: 'sidebar-request-list-for-seller',
          show: isSeller && !isSuperAdmin && (isAccountAdmin || isSellerManager),
          to: `${ERoute.RequestList}/${EUserRole.SellerManager}`,
          icon: <DrawerFull />,
          label: 'Заказы на поставку',
          description: 'Заказы на поставку',
          group: 'body',
          badge: getStatisticsItemCount(statistics.sellerRequestsCount),
        },
        {
          key: 'sidebar-request-list-for-manager',
          show: !isSuperAdmin && isManager,
          to: `${ERoute.RequestList}/${EUserRole.Manager}`,
          icon: <DrawerFull />,
          label: 'Заказы на закупку',
          description: 'Заказы на закупку',
          group: 'body',
          badge: getStatisticsItemCount(statistics.requestsCount),
        },
        {
          key: 'sidebar-request-list-for-user',
          show: !isSeller && !isSuperAdmin,
          to: `${ERoute.RequestList}/${EUserRole.User}`,
          icon: <Drawer />,
          label: 'Мои заказы',
          description: 'Мои заказы',
          group: 'body',
        },
        // Временно скрыто из меню СА
        // {
        //   key: 'sidebar-rfp-list-for-super-admin',
        //   show: isSuperAdmin,
        //   to: `${ERoute.RfpList}/${EUserRole.SuperAdmin}/${ERfpStatus.Active}`,
        //   icon: <Email />,
        //   label: 'Запросы предложений (RFP)',
        //   description: 'Запросы предложений (RFP)',
        //   group: 'body',
        //   badge: getStatisticsItemCount(statistics.rfpCount),
        // },
        // Временно скрыто (RFP убран из интерфейса и у продавцов)
        // {
        //   key: 'sidebar-rfp-list-for-seller',
        //   show: isSeller && !isSuperAdmin && (isAccountAdmin || isSellerManager),
        //   to: `${ERoute.RfpList}/${EUserRole.SellerManager}/${ERfpStatus.Active}`,
        //   icon: <Email />,
        //   label: 'Запросы предложений (RFP)',
        //   description: 'Запросы предложений (RFP)',
        //   group: 'body',
        //   badge: getStatisticsItemCount(statistics.rfpCount),
        // },
      ],
      brightGreenGroup: [
        {
          key: 'sidebar-account-list',
          show: isSuperAdmin,
          to: ERoute.AccountList,
          icon: <Account />,
          label: 'Аккаунты',
          description: 'Аккаунты',
          group: 'body',
        },
        {
          key: 'sidebar-contract-list',
          show: isSuperAdmin,
          to: ERoute.ContractList,
          icon: <Contract />,
          label: 'Контракты',
          description: 'Контракты',
          group: 'body',
        },
        // Временно скрыто из меню СА
        // {
        //   key: 'sidebar-mapper-admin',
        //   show: isSuperAdmin,
        //   to: ERoute.MapperAdminTypes,
        //   icon: <Tool />,
        //   label: 'Каталог mapper’а',
        //   description: 'Каталог mapper’а',
        //   group: 'body',
        // },
        {
          key: 'sidebar-active-basket-list',
          show: isSeller && !isSuperAdmin && (isAccountAdmin || isSellerManager),
          to: ERoute.ActiveBasketList,
          icon: <Cart />,
          label: 'Корзины клиентов',
          description: 'Корзины клиентов',
          group: 'body',
          end: xBasketId ? window.location.pathname.includes(`${ERoute.ActiveBasketList}/${xBasketId}`) : false,
        },
        {
          key: 'sidebar-active-basket',
          show: isSeller && !isSuperAdmin && !!xBasketId,
          to: `${ERoute.ActiveBasketList}/${xBasketId}`,
          icon: <Cart />,
          label: 'Привязанная корзина',
          description: 'Привязанная корзина',
          group: 'body',
        },
        {
          key: 'sidebar-basket',
          show: !isSeller && !isSuperAdmin,
          to: ERoute.Basket,
          icon: <Cart />,
          label: 'Корзина',
          description: 'Корзина',
          group: 'body',
          badge: getStatisticsItemCount(statistics.basketGoodsCount),
        },
        {
          key: 'sidebar-inventory-list-for-user',
          show: !isSeller && !isSuperAdmin,
          to: ERoute.InventoryList,
          icon: <Tool className="icon-tool" />,
          label: 'Учёт инструмента',
          description: 'Учёт инструмента',
          group: 'body',
        },
      ],
    },
    footer: [
      {
        key: 'sidebar-profile',
        show: !isSuperAdmin,
        to: ERoute.Profile,
        icon: <div className="ff-bold fs-xs color-dark-grey">{initials}</div>,
        label: userName,
        description: 'Личный кабинет',
        group: 'footer',
      },
      {
        key: 'sidebar-logout',
        show: true,
        to: '',
        icon: <Exit />,
        label: xUserId ? 'Вернуться в аккаунт суперадминистратора' : 'Выйти',
        description: 'Выйти',
        group: 'footer',
        onClick: logout,
      },
    ],
  };
};

export const getSidebarHeaderSubtitle = (roles?: string[], isSeller?: boolean) => {
  const { isSuperAdmin, isAccountAdmin, isSellerManager, isManager } = getUserRole(roles);

  switch (true) {
    case isSuperAdmin: {
      return 'Суперадмин';
    }
    case isAccountAdmin: {
      if (!isSeller) {
        return 'Настройки аккаунта';
      }

      return 'Администратор';
    }
    case isSellerManager: {
      return 'Менеджер';
    }
    case isManager: {
      return 'Менеджер по закупкам';
    }
    default: {
      return null;
    }
  }
};
